import React from 'react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';
import Workflow from '../components/Workflow';

const V2HandbackReadiness = () => {
  useSEO({
    title: 'Handback Readiness | Continuous, not last-minute',
    description: 'Continuous Handback Readiness for PFI, P3 and PPP. Connect lifecycle, asset condition, operational evidence and contractual assurance, handback is an outcome, not an event.',
    path: '/handback-readiness',
  });

  return (
    <div data-testid="v2-handback-readiness">
      <ProductHero
        eyebrow="Handback readiness"
        title="Don't start preparing for handback at the end."
        subtitle="Make handback readiness part of the way you operate."
        body={(
          <>
            <p>Long-term infrastructure contracts generate years of maintenance records, lifecycle decisions, asset interventions, contractual obligations and operational evidence.</p>
            <p>If those records remain fragmented, handback becomes an exercise in reconstruction.</p>
            <p className="text-slate-800 font-medium">Keystone&rsquo;s approach is based around Continuous Handback Readiness.</p>
            <p className="text-blue-700 italic">Handback is an outcome, not an event.</p>
          </>
        )}
        primary={{ label: 'Talk to Keystone about handback', to: '/contact' }}
        secondary={{ label: 'Explore Videra Vanguard', to: '/videra/vanguard' }}
        heroImage="/images/healthcare/hc-handback-readiness.jpg"
        heroImageAlt="Progressive handback readiness view"
        testid="handback-hero"
      />

      <section className="py-16 md:py-20 bg-slate-50 border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">The handback journey</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 mb-10">From operation to handback ready.</h2>
          <Workflow testid="handback-workflow" steps={['Operate','Maintain','Assess condition','Plan lifecycle','Deliver','Evidence','Assure','Handback ready']} />
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 leading-tight">
            Good handback starts with good lifecycle management.
          </h2>
          <div className="mt-8 text-base lg:text-lg text-slate-700 leading-relaxed space-y-4">
            <p>The condition of an asset at handback is influenced by years of maintenance, investment and lifecycle decisions.</p>
            <p>Every deferred intervention matters. Every completed lifecycle project matters. Every missing record matters.</p>
            <p>Videra connects lifecycle planning, project delivery, evidence and assurance so organisations can progressively understand their developing handback position.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default V2HandbackReadiness;
